import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const PaperSeparator = (props) => <StyledSeparator {...props} />;

const StyledSeparator = styled.span`
  margin: 8px -${(props) => props.margin}px;
  display: block;
  height: 1px;
  background-color: #d8d8d8; // TODO: цвет должен быть из темы
`;

PaperSeparator.defaultProps = {
  margin: 10,
};

PaperSeparator.propTypes = {
  margin: PropTypes.number,
};

export default PaperSeparator;
